<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="glass-strong rounded-xl p-6 w-full max-w-md mx-4">
      <h3 class="text-xl font-bold text-white mb-4">Add User</h3>
      <form @submit.prevent="handleSubmit">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">Name</label>
            <input
              v-model="form.name"
              type="text"
              required
              class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-300 mb-1">Role</label>
            <select
              v-model="form.role"
              class="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white"
            >
              <option value="Admin">Admin</option>
              <option value="User">User</option>
            </select>
          </div>
        </div>
        <div class="flex space-x-3 mt-6">
          <button
            type="button"
            class="flex-1 px-4 py-2 bg-slate-800/70 border border-slate-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-[--ring]"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button type="submit" class="flex-1 px-4 py-2 rounded-lg btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits(['close', 'save'])

const form = ref({
  name: '',
  role: 'User',
})

const handleSubmit = () => {
  const initials = form.value.name
    .trim()
    .split(/\s+/)
    .map((p) => p[0]?.toUpperCase() || '')
    .slice(0, 2)
    .join('')
  emit('save', { ...form.value, initials })
}
</script>
